<div class="reopen-request-form" [attr.aut-id]="autId()">
  
  <cm-textarea-field
    class="reopen-request-form__field cm-form-input"
    [label]="'Reason for reopening'"
    [ariaLabel]="fieldAriaLabel()"
    [placeholder]="placeholder()"
    [formControl]="reasonControl"
    [rows]="rows()"
    [maxlength]="maxLength"
    [resizable]="false"
    [hideErrors]="true"
    [autId]="autId() + '-reason'"
    [required]="true"
  />

  <div class="reopen-request-form__actions">
    <cm-button
      variant="basic"
      color="primary"
      size="sm"
      [disabled]="submitting()"
      [autId]="autId() + '-cancel-btn'"
      (click)="onCancel()"
    >
      {{ cancelLabel() }}
    </cm-button>
    <cm-button
      variant="flat"
      color="primary"
      size="sm"
      [disabled]="!canSubmit()"
      [loading]="submitting()"
      [autId]="autId() + '-submit-btn'"
      (click)="onSubmit()"
    >
      {{ submitLabel() }}
    </cm-button>
  </div>
</div>
